/**
 * Page for collecting organization information during sign up
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import OrgFormContainer from './OrgForm/OrgFormContainer';
import SignUpTemplateContainer from '../SignUpTemplate/SignUpTemplateContainer';

const propTypes = {
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
  handleOrgCreate: PropTypes.func.isRequired,
  handleUpdateSession: PropTypes.func.isRequired,
  user: PropTypes.shape({
    identity: PropTypes.shape({
      ORv4ID: PropTypes.bool,
    }),
  }).isRequired,
};

export function UnstyledOrgInfoPage({ classes, handleOrgCreate, handleUpdateSession, user }) {
  const handleOrgCreateSuccess = () => handleUpdateSession();
  return (
    <SignUpTemplateContainer
      header="Organization Information"
      subheader="Once you finish signing up, you'll be able to invite other users to
      your organization."
      activeStep={1}
      email={false}
      migrated={!!user.identity.ORv4ID}
    >
      <OrgFormContainer
        handleOrgCreate={handleOrgCreate}
        handleOrgCreateSuccess={handleOrgCreateSuccess}
        className={classes.form}
      />
    </SignUpTemplateContainer>
  );
}

UnstyledOrgInfoPage.propTypes = propTypes;

const styles = (theme) => ({
  form: {
    marginTop: theme.spacing(2),

    [theme.breakpoints.down('lg')]: {
      padding: 0,
    },
  },
});

export default withStyles(styles)(UnstyledOrgInfoPage);
